export default "__VITE_PUBLIC_ASSET__88b49d2e__"